import { Divider, Stack } from '@mui/material';
import PropTypes from 'prop-types';
import React from 'react';

import HeaderLogo from '@/components//HeaderLogo/HeaderLogo';
import HeaderBasket from '@/components/HeaderBasket/HeaderBasket';
import LanguagePagePicker from '@/components/LanguagePagePicker/LanguagePagePicker';
import LoginActions from '@/components/PageHeader/LoginActions/LoginActions';
import SearchButton from '@/components/SearchButton/SearchButton';
import PageMargins from '@/components/ui/PageMargins/PageMargins';

import { InnerWrapper, OuterWrapper } from './LowerBar.style';

const LowerBar = ({
  hasNavigation = true,
  languagePagePickerHidden = false,
  loginMenuHidden = false,
  basketHidden = false,
  actionIcons = null,
  onSearchOpen,
}) => {
  const actionElements = [
    { element: <LanguagePagePicker />, visible: !languagePagePickerHidden },
    { element: <LoginActions />, visible: !loginMenuHidden },
    {
      element: <HeaderBasket data-test-subject="header-basket-desktop" />,
      visible: !basketHidden,
    },
  ].filter(({ visible }) => visible);

  return (
    <OuterWrapper bgcolor="common.white" hasNavigation={hasNavigation}>
      <PageMargins>
        <InnerWrapper
          direction="row"
          justifyContent="space-between"
          alignItems="center"
          hasNavigation={hasNavigation}>
          <HeaderLogo data-test-subject="header-logo-link" />
          <Stack direction="row" alignItems="center">
            <SearchButton onSearchOpen={onSearchOpen} />
            <Divider
              orientation="vertical"
              sx={{
                height: 20,
                mx: 1,
              }}
            />
            {actionIcons}
            {actionElements.map(({ element }, index) => (
              <React.Fragment key={index}>
                {index > 0 && (
                  <Divider
                    orientation="vertical"
                    sx={{
                      height: 20,
                      mx: 1,
                    }}
                  />
                )}
                {element}
              </React.Fragment>
            ))}
          </Stack>
        </InnerWrapper>
      </PageMargins>
    </OuterWrapper>
  );
};

LowerBar.propTypes = {
  hasNavigation: PropTypes.bool,
  languagePagePickerHidden: PropTypes.bool,
  basketHidden: PropTypes.bool,
  loginMenuHidden: PropTypes.bool,
  actionIcons: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.arrayOf(PropTypes.element),
  ]),
};

export default LowerBar;
